import ReactMarkdown from "react-markdown";

const ReactMarkdownMod = ({ args }) => {
  return (
    <ReactMarkdown
      components={{
        ul: ({ node, ...props }) => (
          <ul {...props} style={{ marginTop: "-2.5rem", padding: 0 }}>
            {props.children}
          </ul>
        ),

        li: ({ node, ...props }) => (
          <li
            {...props}
            style={{ display: "inline-block", margin: "0 10px", padding: 0 }}
          >
            {props.children}
          </li>
        ),
        strong: ({ node, ...props }) => (
          <strong style={{ fontWeight: "bold", color: "inherit" }}>
            {props.children}
          </strong>
        ),
        em: ({ node, ...props }) => (
          <em style={{ fontStyle: "italic", color: "inherit" }}>
            {props.children}
          </em>
        ),
        u: ({ node, ...props }) => (
          <u style={{ textDecoration: "underline", color: "inherit" }}>
            {props.children}
          </u>
        ),
        blockquote: ({ node, ...props }) => (
          <blockquote
            style={{
              margin: "1rem 0",
              paddingLeft: "1rem",
              borderLeft: "4px solid #ccc",
              color: "#555",
              fontStyle: "italic",
            }}
          >
            {props.children}
          </blockquote>
        ),
        code: ({ node, inline, ...props }) => (
          <code
            style={{
              backgroundColor: "#f5f5f5",
              padding: "0.2em 0.4em",
              borderRadius: "4px",
              fontFamily: "monospace",
            }}
          >
            {props.children}
          </code>
        ),
        a: ({ node, ...props }) => (
          <a
            {...props}
            style={{
              color: "", // Customize link color
              textDecoration: "underline",
            }}
            target="_blank" // Open links in a new tab
            rel="noopener noreferrer" // Security feature for links
          >
            {props.children}
          </a>
        ),
      }}
    >
      {args}
    </ReactMarkdown>
  );
};

export default ReactMarkdownMod;
